// src/router.ts
import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import About from '@/views/About.vue'
import Contact from '@/views/Contact.vue'
import Details from '@/views/Details.vue'
import DailyDeals from '@/views/DailyDeals.vue'
import Blog from '@/views/Blog.vue'
import BlogPost from '@/views/BlogPost.vue' 
import BlogOld from '@/views/BlogOld.vue'
import Article from '@/views/Article.vue'
import PrivacyPolicy from '@/views/PrivacyPolicy.vue'
import Backend from '@/views/Backend.vue'
import Analytics from '@/views/Analytics.vue'
import DealSearch from '@/views/DealSearch.vue'
import Landing from '@/views/Landing.vue'
import StartShopping from '@/views/StartShopping.vue'
import DealNumber from '@/views/DealNumber.vue'
import DealShare from '@/views/DealShare.vue'
import GiftListManager from '@/views/GiftListManager.vue'
import GiftCenter from '@/views/GiftCenter.vue'
import AdvancedAmazonSearch from '@/views/AdvancedAmazonSearch.vue'
import Outlet from '@/views/Outlet.vue'
import GiftIdeas from '@/views/GiftIdeas.vue'
import SearchResults from '@/views/SearchResults.vue'
import AITrain from '@/views/AITrain.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
},
{
    path: '/about',
    name: 'about',
    component: About
},
{
    path: '/contact',
    name: 'contact',
    component: Contact
},
//{
//    path: '/giveaway',
//    name: 'giveaway',
//    component: Giveaway2
//},
{
    path: '/deal/:id',
    name: 'deal',
    component: Details
},
{
    path: '/daily-deals/:date',
    name: 'dailydeals',
    component: DailyDeals
},
{
    path: '/deal/:id/:title',
    name: 'deal2',
    component: Details
},
{
    path: '/blog',
    name: 'blog',
    component: Blog
},
{
    path: '/blog/:slug',
    name: 'blog-post',
    component: BlogPost
},
{
    path: '/lists',
    name: 'lists',
    component: BlogOld
},
{
    path: '/list/:id',
    name: 'article',
    component: Article
},
{
    path: '/list/:id/:title',
    name: 'article2',
    component: Article
},
{
    path: '/privacy-policy',
    name: 'privacy',
    component: PrivacyPolicy
},
{
    path: '/backend',
    name: 'backend',
    component: Backend
},
{
    path: '/analytics',
    name: 'analytics',
    component: Analytics
},
//{
//    path: '/analysis',
//    name: 'analysis',
//    component: Analysis
//},
{
    path: '/deal-search',
    name: 'dealsearch',
    component: DealSearch
},
{
    path: '/p/:landing',
    name: 'landing',
    component: Landing
},
{
    path: '/shopping/:id',
    name: 'startShopping',
    component: StartShopping
},
{
    path: '/dealnumber',
    name: 'dealnumber',
    component: DealNumber
},
{
    path: '/dealshare',
    name: 'dealshare',
    component: DealShare
},
{
    path: '/aitrain',
    name: 'aitrain',
    component: AITrain
},
{
    path: '/gift-list-manager',
    name: 'giftlistmanager',
    component: GiftListManager
},
{
    path: '/gift-ideas',
    name: 'giftideas',
    component: GiftCenter
},
{
    path: '/gift-ideas/:id',
    name: 'giftlist',
    component: GiftIdeas
},
{
    path: '/gift-ideas/:id/:title',
    name: 'giftlist2',
    component: GiftIdeas
},
{
    path: '/advanced-amazon-search',
    name: 'advanced-amazon-search',
    component: AdvancedAmazonSearch
},
{
    path: '/search-results',
    name: 'search-results',
    component: SearchResults
},
{
    path: '/outlet',
    name: 'outlet',
    component: Outlet
},
{
    path: '/outlet/:categories(.*)*',
    name: 'outlet',
    component: Outlet
}
]

// page scroll to top for all route navigations

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router
